module.exports = __webpack_public_path__ + "img/upload-files.55aefb9c.png";